module.exports = __webpack_public_path__ + "img/cju_gallery4.c661b5d0.jpg";